// extracted by mini-css-extract-plugin
export var divider = "_qz-0";
export var systemMessage = "_qz-1";